import React from 'react';
import Home from './components/Home';
import { GlobalStyle } from './GlobalStyles';

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Home />
    </>
  );
};

export default App;
